import React from "react";
import OSM from "../assets/images/osm.svg";

function Footer() {
  return (
    <footer id="footer">
            <div className="footer-row">
                <a href="https://www.facebook.com/groups/571395473278594/" target="_blank"><i className="fa fa-facebook"></i></a>
                <a href="https://www.onlinescoutmanager.co.uk/" target="_blank"><img src={OSM} alt="OSM Logo"></img></a>
            </div>
        
            <div className="footer-row">
                <ul>
                    <li><a href="https://www.scouts.org.uk/about-us/policy/safeguarding-policy-and-procedures/" target="_blank">Safeguarding</a></li>
                    <li><a href="https://www.scouts.org.uk/about-us/policy/data-protection-policy/" target="_blank">Data Protection Policy</a></li>
                    <li><a href="https://www.scouts.org.uk/about-us/policy/" target="_blank">All Policies</a></li>
                </ul>
            </div>
            <div className="footer-row">
                <p>&copy; 2024 17th Bournemouth Scout Group</p>
            </div>
            <div className="footer-row">
                <div id="github-container">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg" alt="GitHub Logo" width="40" height="40"></img>
                    <a id="github" href="https://github.com/oliverwhittle" target="_blank">Website created by Oliver 'Hawkeye' Whittle</a>
                </div>
            </div>
    </footer>
  );
}

export default Footer;